import { Chip as MuiChip } from "@mui/material";

declare module "@mui/material/Chip" {
  interface ChipPropsSizeOverrides {
    large: boolean;
  }
}

export const Chip = MuiChip;
